<template>
  <div style="width:100%" v-if="week">
    <div class="calendar-week">
      <div class="calendar-week__head">
        <div class="calendar-week__title">Woche {{ weekTitle }}</div>

        <div class="hours">
          <div class="hour" v-for="(item, index) in hours" :key="index">{{ item }}</div>
        </div>
      </div>

      <template v-for="(item, index) in week.data">
        <div class="week" :key="index" :id="index" :ref="index">
          <div class="week-day">
            <div class="week-day__head">
              <p>{{ prepareWeekDate(index) }}</p>
            </div>
            <div class="week-day__body">
              <template v-for="(service, serviceSlug) in item">
                <div
                  class="week-day__service"
                  :key="serviceSlug"
                  v-if="
                    activeService === 'all' ||
                      !activeService ||
                      activeService === serviceInfo(serviceSlug, 'id')
                  "
                >
                  <div class="week-day__service-head">
                    <p>{{ serviceInfo(serviceSlug, "text") }}</p>
                    <button
                      class="week-day__add"
                      @click="
                        openRequestModal(serviceInfo(serviceSlug, 'id'), index)
                      "
                    >add order</button>
                  </div>

                  <template v-for="master in service">
                    <template>
                      <div class="week-day__master" :key="master.master.id">
                        <div class="week-day__master-name">
                          {{ master.master.first_name }}
                          {{ master.master.last_name }}
                        </div>
                        <div class="week-day__master-schedule week-schedule">
                          <div
                            class="week-day__order"
                            v-for="request in master.orders"
                            :key="request.id"
                            :style="{
                              left: _getHoursOffset2(
                                request.should_started_at,
                                1440,
                                0
                              ),
                              backgroundColor: serviceInfo(
                                serviceSlug,
                                'color'
                              ),
                              width: _getWidthBlockWeek(
                                request.should_started_at,
                                request.predicted_time,
                                1440
                              ),
                              'margin-left':
                                request.predicted_time > 480 ? '1px' : '',
                            }"
                            @click="openOrderModal(request.request_id)"
                          ></div>
                          <div
                            class="main-schedule"
                            :style="{
                              left: getScheduleOffset(master.schedule),
                              width: getScheduleWidth(master.schedule),
                            }"
                          >
                            <!-- {{ master.schedule }} -->
                          </div>
                        </div>
                      </div>
                    </template>
                  </template>
                </div>
              </template>
            </div>
          </div>
        </div>
      </template>
    </div>

    <modal :show="showModalAdd" @close="toggleShowModalAdd" :dark="true" :outside="false">
      <transition name="showmodal">
        <request-add-modal v-if="showModalAdd" @close="toggleShowModalAdd" @done="updateCalendar" />
      </transition>
    </modal>

    <modal :show="showModal" @close="setToggleModal" :dark="true" :outside="false">
      <transition name="showmodal">
        <orders-modal @done="updateCalendar" />
      </transition>
    </modal>
  </div>
</template>

<script>
import moment from 'moment'
import calendar from '@/mixins/calendar'
import requestAddModal from '@/components/modals/requests/requestAddModal'
import ordersModal from '@/components/modals/orders/ordersModal'

import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
    props: ['toDay'],
    mixins: [calendar],
    components: {
        requestAddModal,
        ordersModal,
    },
    filters: {
        filterTime(time) {
            return moment(time * 1000).format('HH:mm')
        },
    },
    data() {
        return {
            glideSettings: {
                type: 'slider',
                startAt: new Date().getDate() - 1,
                perView: 4,
                peek: 120,
                rewindDuration: 0,
                throttle: 0,
                focusAt: 3,
            },
            hours: [
                '00:00',
                '01:00',
                '02:00',
                '03:00',
                '04:00',
                '05:00',
                '06:00',
                '07:00',
                '08:00',
                '09:00',
                '10:00',
                '11:00',
                '12:00',
                '13:00',
                '14:00',
                '15:00',
                '16:00',
                '17:00',
                '18:00',
                '19:00',
                '20:00',
                '21:00',
                '22:00',
                '23:00',
            ],
            days: [
                { name: 'Monday', date: '09:06' },
                { name: 'Tuesday', date: '10:06' },
                { name: 'Wednesday', date: '11:06' },
            ],
            defaultWeekIndex: this.weekIndex,
            isLoad: false,
        }
    },
    computed: {
        ...mapGetters({
            masters: 'specialists/getSpecialists',
            services: 'servicesGetters',
            showModalAdd: 'requests/showModalAdd',
            activeService: 'serviceGetters',
            showModal: 'orders/showModal',
            week: 'weekGetters',
            weekTitle: 'weekTitleGetters',
        }),
        masterWeekView() {
            if (this.$route.params && this.$route.params.employee_id) {
                return this.$route.params.employee_id
            }

            return null
        },
    },
    methods: {
        ...mapActions({
            fetchMasters: 'specialists/getSpecialistsData',
            fetchById: 'orders/fetchById',
        }),
        ...mapMutations({
            toggleShowModalAdd: 'requests/toggleShowModalAdd',
            setFormData: 'requests/setFormData',
            setToggleModal: 'orders/setToggleModal',
        }),
        getScheduleOffset(schedule) {
            // const part = 100 / 24;
            // if (!schedule.time_from) return 100 / 24 + "%";

            // const currentStart = 8;
            // const scheduleStart = schedule.time_from.split(":")[0];

            // return (scheduleStart - currentStart) * part + "%";

            const part = 100 / 24
            if (!schedule.time_from) return '0%'

            const scheduleStart = schedule.time_from.split(':')[0]

            return `${scheduleStart * part}%`
        },
        getScheduleWidth(schedule) {
            const part = 100 / 24
            if (!schedule.time_till) return '0'

            const scheduleStartFrom = +schedule.time_from.split(':')[0]
            const scheduleStartTill = +schedule.time_till.split(':')[0]

            const parts = (scheduleStartTill - scheduleStartFrom) * part
            // return (scheduleStart - currentStart) * part + "%";
            return `${parts}%`
        },
        updateCalendar() {
            setTimeout(() => {
                this.$emit('updateWeekCalendar')
            }, 2000)
        },
        serviceInfo(slug, key = null) {
            const service = this.services.find((item) => item.slug === slug)
            return !key ? service : service[key]
        },
        async openOrderModal(v) {
            await this.fetchById(v)
            this.setToggleModal()
        },
        getDate(v) {
            const localDate = v === null ? moment().add(1, 'd') : moment(v, 'DD/MM/YYYY')

            return moment(moment(localDate).format('YYYY-MM-DDT22:00:00.000[Z]'))
                .set({
                    hour: 8, minute: 0, second: 0, millisecond: 0,
                })
                .subtract(1, 'd')
                .toISOString()
        },
        openRequestModal(id, day) {
            this.setFormData({ key: 'service_id', value: id })
            this.setFormData({
                key: 'dateOptions',
                value: { text: this.getDate(moment(day)), value: null },
            })
            this.toggleShowModalAdd()
        },
        nextSlide() {
            this.$refs.gallery.glide.go('>')
        },
        prevSlide() {
            this.$refs.gallery.glide.go('<')
        },
        getEmployeeBusyness(data) {
            let time = 0
            if (data) {
                data.requests.forEach((element) => {
                    time += (element.date_till - element.date_from) / 3600
                })
            }
            return time
        },
        prepareWeekDate(day) {
            return moment(day).format('dddd D/MM/YY')
        },
    },
    mounted() {
        const day = moment(this.toDay).format('YYYY-MM-DD')

        if (!this.$refs[day]) {
            return
        }

        const el = this.$refs[day][0]
        el.parentNode.scrollTop = el.offsetTop - 65
    },
}
</script>
<style lang="scss">
@import "src/assets/sass/main";

.next-week__button {
  position: absolute;
  right: -45px;
  top: 45%;
  width: 30px;
  height: 90px;
  background-image: url(/images/icon/slider-arrow-next.svg);
  background-size: cover;
  background-position: center;
  cursor: pointer;
}
.prev-week__button {
  position: absolute;
  left: -45px;
  top: 45%;
  width: 30px;
  height: 90px;
  background-image: url(/images/icon/slider-arrow-prev.svg);
  background-size: cover;
  background-position: center;
  cursor: pointer;
}

.week {
  margin-bottom: 20px;

  &:not(:last-child) {
    border-bottom: 1px solid var(--border-color);
  }
  p {
    margin: 0;
  }

  &-day {
    &__head {
      margin-bottom: 8px;
      font-size: 18px;
      padding-left: 20px;
      font-family: "crosten-bold";
    }

    &__master {
      display: flex;
      align-items: center;
      width: 100%;
      padding: 4px 0;
      transition: all 0.3s ease-in;
      box-sizing: border-box;

      &:hover {
        background-color: #a980df29;
      }
      &-name {
        width: 200px;
        box-sizing: border-box;
        padding-left: 20px;
      }
    }

    &__service {
      margin-bottom: 16px;
      // padding-left: 20px;
      box-sizing: border-box;

      &-head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 200px;
        height: 100%;
        font-weight: bold;
        font-size: 14px;
        margin-bottom: 8px;
        padding-left: 20px;
        box-sizing: border-box;
      }
    }

    &__add {
      background-color: transparent;
      width: 80px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: var(--bg-color-green);
      color: #fff;
      border: none;
      padding: 5px;
      border-radius: 4px;
      font-size: 13px;
      cursor: pointer;
      transition: all 0.3s ease-in;
      outline: none;

      &:hover {
        background-color: #eddf07;
      }
    }

    &__master-schedule {
      position: relative;
    }

    &__order {
      position: absolute;
      z-index: 3;
      height: 100%;
      cursor: pointer;
      // &_n1 {
      //   width: 15%;
      //   left: 20%;
      //   background-color: rgb(251, 242, 0);
      // }

      // &_n2 {
      //   left: 60%;
      //   width: 10%;
      //   background-color: rgb(45, 217, 255);
      // }
    }
  }

  &-schedule {
    width: calc(100% - 200px);
    height: 8px;
    // background-color: rgba(155, 205, 130, 0.3);
    position: relative;
    z-index: 2;
  }
}

.main-schedule {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: rgba(155, 205, 130, 0.3);
}
.calendar-week {
  position: relative;
  box-sizing: border-box;
  padding: 70px 0 0 0;
  width: 100%;
  height: 87vh;
  background-color: var(--bg-color2);
  color: var(--menu-text-color);
  overflow-y: scroll;
  overflow-x: hidden;

  &__head {
    display: flex;
    font-size: 14px;
    color: rgba(77, 77, 77, 0.5);
    border-bottom: 1px solid var(--border-color);
    position: fixed;
    width: calc(100% - 247px);
    margin-top: -70px;
    background-color: var(--bg-color2);
    z-index: 3;
    height: 40px;
    display: flex;
  }

  &__title {
    width: 200px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    color: var(--menu-text-color);
    background-color: var(--bg-color);
  }
}

.hours {
  display: flex;
  width: calc(100% - 200px);
  justify-content: space-between;
  height: 100%;

  .hour {
    height: 100%;
    width: calc(100% / 11);
    display: flex;
    justify-content: center;
    align-items: center;
    border-left: 1px solid var(--border-color);
    color: var(--label-color);
    font-size: 11px;

    &:not(:last-child) {
      border-right: 1px solid var(--border-color);
    }
  }
}
</style>
